import { Accordion as AccordionPrimitive } from 'radix-ui'
import * as React from 'react'
import { LuChevronDown } from 'react-icons/lu'

import { cn } from '@/lib/utils'

function Accordion({
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Root>) {
  return <AccordionPrimitive.Root data-slot="accordion" {...props} />
}

function AccordionItem({
  className,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Item>) {
  return (
    <AccordionPrimitive.Item
      data-slot="accordion-item"
      className={cn('border-b last:border-b-0', className)}
      {...props}
    />
  )
}

function AccordionTrigger({
  className,
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Trigger> & {}) {
  return (
    <AccordionPrimitive.Header className="mb-0 flex">
      <AccordionPrimitive.Trigger
        data-slot="accordion-trigger"
        className={cn(
          `focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1
          items-start justify-between gap-4 rounded-md py-4 text-left text-sm
          font-medium transition-all outline-none hover:underline
          focus-visible:ring-[3px] data-[disabled]:pointer-events-none
          data-[disabled]:opacity-50 [&[data-state=open]>svg]:rotate-180`,
          className,
        )}
        {...props}
        asChild
      >
        <div>
          {children}
          <AccordionChevronDownIcon />
        </div>
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  )
}

function AccordionChevronDownIcon({
  className,
  ...props
}: React.ComponentProps<typeof LuChevronDown>) {
  return (
    <LuChevronDown
      className={cn(
        `text-muted-foreground pointer-events-none size-4 shrink-0
        translate-y-0.5 transition-transform duration-200`,
        className,
      )}
      {...props}
    />
  )
}

function AccordionContent({
  className,
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Content>) {
  return (
    <AccordionPrimitive.Content
      data-slot="accordion-content"
      className="data-[state=closed]:animate-accordion-up
        data-[state=open]:animate-accordion-down overflow-hidden text-sm
        leading-normal"
      {...props}
    >
      <div className={cn('pt-0 pb-4', className)}>{children}</div>
    </AccordionPrimitive.Content>
  )
}

export {
  Accordion,
  AccordionChevronDownIcon,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
}
